<template>
    <div class="container"  v-title="title">
        <Navigation-bar id="navigation_bar" type="dark" :title="title"></Navigation-bar>
        <div class="container_content">
            <div id="HelpCenter_detail">
                <div class="HelpCenter_content" v-html="contentHtml"></div>
            </div>
        </div>
        <ImagePreview v-model="show" :images="images" :start-position="index"></ImagePreview>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
import { get } from '@/api/htmlRequest'
export default {
    name: 'HelpCenterDetail',
    components: {
        ImagePreview: ImagePreview.Component
    },
    data() {
        return {
            title: decodeURIComponent(this.$route.query.title),
            contentHtml:'',
            images:[],
            index:0,
            show:false
        }
    },
    created(){
        get(process.env.VUE_APP_PUBLIC_URL + `/html/帮助中心/web/${this.title}.html`).then(data=>{
            this.contentHtml = data.replace(/images\//igm, process.env.VUE_APP_PUBLIC_URL + '/html/帮助中心/images/');
            this.$nextTick(function(){
                var images = [];
                var _this = this;
                var imgs = document.querySelectorAll('#HelpCenter_detail img');
                console.log(imgs);
                imgs.forEach((item, index) => {
                    images.push(item.getAttribute('src').replace('@2x','@3x'));
                    item.setAttribute('data-index', index);
                    item.onclick = function(){
                        _this.index = parseInt(this.getAttribute('data-index'));
                        _this.show = true;
                    }
                })
                this.images = images;
            })
        })
    }
};
</script>
<style lang="scss" scoped>
.title{
    height: 198px;
    padding: 24px 40px 0;
    box-sizing: border-box;
    background: #1B1C1E;
    position: relative;
    h2{
        @include line-height(84px);
        font-size: 60px;
        color: #FFFFFF;
        font-weight: 500;
    }
    .logo{
        width: 222px;
        height: 52px;
        position:absolute;
        right: 40px;
        top: 40px;
    }
    p{
        @include line-height(44px);
        font-size: 32px;
        color: #999999;
        font-weight: 400;
        margin-top: 6px;
    }
}
</style>
<style lang="scss">
#HelpCenter_detail{
    .HelpCenter_content{
        padding: 40px;
		padding-bottom: calc(40px + var(--safe-area-inset-bottom));
        box-sizing: border-box;
        p{
            min-height: 28px;
            font-size: 28px;
            color: #4D5561;
            line-height: 44px;
            font-weight: 400;
        }
        .t1{
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            line-height: 44px;
            margin-left: -18px;
        }
        .t2{
            padding-left: 48px;
            box-sizing: border-box;
            font-size: 30px;
            color: #1B1C1E;
            font-weight: 500;
            line-height: 42px;
            position: relative;
            margin-bottom: 24px;
            margin-top: 40px;
            &::before{
                content: '';
                width: 32px;
                height: 32px;
                background: #1B1C1E;
                border-radius: 50%;
                display: block;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
        img{
            width: 100%;
            margin-top: 15px;
            &.l{
                width: 332px;
                display: inline-block;
                margin-left: -1px;
            }
            &.r{
                width: 332px;
                display: inline-block;
                margin-right: -1px;
            }
        }
        img+p{
            margin-top: 24px;
        }
        img+.t2{
            margin-top: 48px;
        }
        p+.t1{
            margin-top: 56px;
        }
    }
}
.van-image-preview{
    .van-image-preview__index{
        font-size: 26px;
    }
}
</style>